import items from './items';
import store from './store';
import show from './show';
import update from './update';
import destroy from './destroy';
import test from './test';
import sendReport from './sendReport';
import newsEmailTrackings from './newsEmailTrackings';

export default {
  items,
  store,
  show,
  update,
  destroy,
  test,
  sendReport,
  newsEmailTrackings,
};



// WEBPACK FOOTER //
// ./src/app/services/news/index.js